import React, { useEffect, useState } from 'react';
import Firebase from './firebase';
import LoadingScreen from '../Loading';

const FirebaseContext = React.createContext(null);

const useFirebase = () => React.useContext(FirebaseContext);

export const FirebaseProvider = ({ children }) => {
  const [firebase, setFirebase] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const loadFirebase = async () => {
    setLoading(true);
    //const fb = await FirebaseObj();
    //setFirebase(fb);
    const fb = await new Firebase();
    setFirebase(fb);
    setLoading(false);
  };

  useEffect(() => {
    if (firebase === undefined) {
      console.debug('loading firebase');
      loadFirebase();
    }
  }, [firebase]);

  const loadingScreen = () => <LoadingScreen open={loading} />;

  const provider = () => (
    <FirebaseContext.Provider value={firebase}>
      {children}
    </FirebaseContext.Provider>
  );
  if (firebase === undefined) return loadingScreen();
  return provider();
};

export default useFirebase;
